// @ts-expect-error this is react 19 feature; types reference 18
import { createRoot } from "react-dom/client";
import "./styles/styles.scss";
import { App } from "./App.tsx";
import { fetchInitialGlobalContext } from "./utils/GlobalContext.ts";
import { ClientLayout } from "./components/layout/ClientLayout.tsx";
import { NotFound } from "./components/pages/NotFound/NotFound.tsx";

(async () => {
  const app = await (async () => {
    try {
      const globalContext = await fetchInitialGlobalContext();
      return (
        <ClientLayout>
          <App globalContext={globalContext} />
        </ClientLayout>
      );
    } catch (e) {
      return (
        <ClientLayout>
          <NotFound />
        </ClientLayout>
      );
    }
  })();

  createRoot(document.getElementById("root")!).render(app);
})();
